import React from 'react';
import { Navigate, useParams } from 'react-router';
import { lscPath } from '../routing';

/** Legacy bookmark path → League Settings archive automation sub-page. */
const LscArchiveAutomationRedirect: React.FC = () => {
  const { leagueId } = useParams<{ leagueId: string }>();

  if (!leagueId) {
    return <Navigate to="/leagues" replace />;
  }

  return (
    <Navigate
      to={lscPath(`/leagues/${leagueId}/settings/archive-automation`)}
      replace
    />
  );
};

export default LscArchiveAutomationRedirect;
